import { isUuid } from "./Utils"

export default class QueryActions{

    /**
     * Analyze the url query string and based on the keys and values found execute some actions
     */
    static analyzeQueryString(spread_element, activeLayout){
        let actions = new Map;
        //check if there is a querystring
        if(location.search.indexOf("?") > -1){
            let i, key_value, query_str, query_split, query;
            //remove the ?
            query_str = location.search.substr(1);
            //split the query in key=value pairs
            query_split = query_str.split("&");
            //loop all pairs to create an object with property(key) = value
            for(i = 0; i < query_split.length; i++){
                key_value = query_split[i].split("=");

                let {key, value} = QueryActions.executeActions(key_value[0], key_value[1], spread_element, activeLayout);
                if(value){
                    actions.set(key, value);
                }
            }
            //console.log( 'analyzeQueryString', actions );
        }
        return actions;
    }

    static executeActions(action, value, spread_element, activeLayout){
        switch (action){
            case 'scene':
                if (value) {
                    if( !isUuid(value) ){ // test if value is not an uuid,
                        //not an uuid so try to find a scene with the value as label
                        const scene = spread_element.querySelector(`.layout.${activeLayout === 1 ? 'desktop' : 'mobile'} .scene[data-label='${decodeURI(value)}']`);
                        if (scene) {
                            value = scene.id;
                        }
                    }
                    return { key : "sceneDeepLink", value : value};
                }

                break;
            case 'element':
                if (value) {
                    let element = false
                    const layoutContainer = spread_element.querySelectorAll('.layout')[activeLayout - 1]
                    if( isUuid(value) ){ // test if value is a valid uuid,
                        element = layoutContainer.querySelector(`.element[id*=${decodeURI(value)}]`);
                    } else {
                        element = layoutContainer.querySelector(`.element[data-label='${decodeURI(value)}']`);
                    }
                    return { key : "elementDeepLink", value : element};
                }
                break;
            case 'disable-animations':
                return { key : "disabledAnimations", value : true};
                break;
            // case 'no-animations':
            //     if(query_obj[action] !== "false"){
            //         Utils._getSelector(".animated").removeClass("animated"); // remove animated tags
            //     }
            //     break;
            default:
                console.log(`action: [${action}] not configured.`);
                break;
        }
        return false;
    }
}
